import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../route.animation';

import {AuthenticationService} from '../../../_services/authentication.service';
import {FormBuilder, Validators} from '@angular/forms';
import {FormsService} from '../../../_services/forms.service';
import {Subscription} from 'rxjs/Subscription';
import {LocalStorageService} from '../../../_services/local-storage.service';
import {TranslateService} from '@ngx-translate/core';
import {PageTitleService} from '../../../_services/page-title.service';

@Component({
	selector: 'app-login-with-recovery-code',
	templateUrl: './login-with-recovery-code.component.html',
	styleUrls: ['./login-with-recovery-code.component.scss'],
	animations: [routeAnimation]
})

export class LoginWithRecoveryCodeComponent implements OnInit, OnDestroy {
	@HostBinding('@routeAnimation') routerTransition = true;

	public sessionId: string = null;
	public otpForm = this.formBuilder.group({
		sessionID: ['', Validators.required],
		code: ['', [Validators.required, Validators.minLength(21), Validators.maxLength(21)]]
	});

	private _errorSubscription: Subscription = null;

	constructor(public authenticationService: AuthenticationService,
				private formBuilder: FormBuilder,
				private localStorageService: LocalStorageService,
				private translate: TranslateService,
				private pageTitleService: PageTitleService,
				public formService: FormsService) {
	}

	ngOnInit(): void {
		this.translate.get('auth.two-factor-recovery-code-login.page-title').subscribe(text => this.pageTitleService.setTitle(text));

		this.formService.form = this.otpForm;

		this.otpForm.get('sessionID').setValue(this.localStorageService.get('sessionID'));

		this._errorSubscription = this.authenticationService.errors.subscribe(errors => {
			this.formService.processErrors(errors);
		});
	}

	ngOnDestroy() {
		if (this._errorSubscription !== null) {
			this._errorSubscription.unsubscribe();
		}
	}
}
